/** The TinyMCE setup every rich-text field in the back office shares. */
export const EDITOR_PLUGINS =
  'anchor autolink charmap codesample emoticons link lists searchreplace table visualblocks wordcount';

export const EDITOR_TOOLBAR =
  'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat';
